import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Grade de Horários',
    path: '/ferramentas/grade_horario',
    name: 'grade_horario',
    component: () => import('@/views/ferramentas/grade_horario/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_GERADOR_MENU_2500300100
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Gerador Grade de Horários',
    path: '/ferramentas/grade_horario/gerador/:id?',
    parent: 'grade_horario',
    name: 'grade_horario_gerador',
    component: () => import('@/views/ferramentas/grade_horario/gerador.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_GERADOR_MENU_2500300100
      ],
    },
    goesToMenu: true,
  },
]

